module.exports = __webpack_public_path__ + "img/Picto_Form_02.90490322.svg";